<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-voice`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.03 22a1 1 0 01.999.95l.01.178C8.618 31.438 15.543 38 24 38c8.364 0 15.23-6.418 15.94-14.598l.024-.324.008-.13A1 1 0 0140.97 22h2.004a1 1 0 011 1l-.003.086c-.528 9.876-8.222 17.85-17.976 18.816l.004.048L26 45a1 1 0 01-1 1h-2a1 1 0 01-1-1v-3l.005-.098c-9.613-.952-17.225-8.71-17.949-18.389l-.029-.466a1 1 0 01.836-1.034l.14-.013H7.03zM24 2c6.627 0 12 4.776 12 10.667v10.666C36 29.224 30.627 34 24 34s-12-4.776-12-10.667V12.667C12 6.776 17.373 2 24 2zm0 4c-4.418 0-8 3.07-8 6.857v10.286C16 26.93 19.582 30 24 30s8-3.07 8-6.857V12.857C32 9.07 28.418 6 24 6z"/></svg>
</template>
<script>

export default {
  name: 'IconVoice',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
